/** Zustand persist key — keep in sync with `authStore` persist `name`. */
export const AUTH_PERSIST_KEY = "retailpro-auth";

/** POS cart holds in `PosScreen`. */
export const POS_HOLDS_STORAGE_KEY = "retailpro_pos_holds";
